reporte-contactos_t3.vue<template>
  <div class="mt-0 pt-0">
    <v-card class="elevation-2" outlined>
      <v-card-title class="d-flex flex-wrap align-center pb-0" style="gap: 12px;">
        <div>
          <div class="text-h6">Registros de estudiantes en programas</div>
        </div>
        <v-spacer></v-spacer> 
        <v-chip color="blue-grey lighten-5" class="blue-grey--text text--darken-3" small>
          encontrados: {{ inscripciones.length }}
        </v-chip>
      </v-card-title>

      <v-card-text class="pt-1 mt-0">
        <v-row dense class="mb-2 py-1" style="background: #fffeff;border: 1px dashed #d6b2d6">
          <v-col cols="12" md="2">
            <v-text-field
              v-model="gestion"
              dense
              outlined
              type="number"
              label="Gestion del programa:"
              hide-details
            />
          </v-col>
          <v-col cols="12" md="4" lg="3">
            <v-combobox 
              v-model="sedeSeleccionada" 
              :items="$store.state.CARGOS"  
              item-text="nombre"
              hide-details
              outlined
              dense
              label="Sede de programas:"
              clearable
            ></v-combobox> 
          </v-col>
          <v-col cols="12" md="4" lg="3">
            <v-combobox 
              v-model="asesor" 
              :items="asesores" 
              :loading="isLoadingAsesores"
              :disabled="!sedeSeleccionada || !sel_todos_asesores"
              hide-details
              outlined
              dense
              label="Asesor:"
              :clearable="sel_todos_asesores"
            ></v-combobox>
          </v-col>

          <v-col cols="12" md="4" lg="2">
            <v-combobox 
              v-model="estado_administrativo" 
              :items="estados_admins"  
              :disabled="!mostrarEstadoAdmin"
              hide-details
              outlined
              dense
              clearable
              label="Estado Administrativo:"
            ></v-combobox>
          </v-col>
          <v-col cols="12" md="4" lg="2">
            <v-combobox 
              v-model="unidad_negocio" 
              :items="unidades"  
              hide-details
              outlined
              dense
              clearable
              label="Unidad negocio:"
            ></v-combobox>
          </v-col>
          <v-col cols="12" md="4" lg="3">
            <v-combobox 
              v-model="convenio" 
              :items="convenios"  
              hide-details
              outlined
              dense
              clearable
              label="Convenio:"
            ></v-combobox>
          </v-col>
          <v-col cols="12" md="2">
            <v-text-field
              v-model="estado_programa_padre_id"
              dense
              outlined
              type="number"
              label="Estado del programa:"
              hide-details
            />
          </v-col>
          <v-col cols="12" md="4" lg="3">
            <v-btn color="green" class="text-none" dark depressed :loading="loading" @click="listar">
              <v-icon left>mdi-refresh</v-icon>
              Aplicar filtros
            </v-btn> 
          </v-col>
        </v-row>
        
        <v-chip v-if="terminos" color="blue lighten-5" class="blue--text text--darken-3 mb-2" small >
          {{ terminos.title || 'Terminos' }} - {{ terminos.version_code || 'S/V' }}
        </v-chip> 

        <v-alert v-if="msg" dense outlined type="warning" class="mb-2">
          {{ msg }}
        </v-alert>

        <!-- Tabla Resumen por Programa -->
        <div class="mb-3">
          <div class="d-flex align-center justify-space-between mb-1">
            <div class="text-subtitle-2 font-weight-bold grey--text text--darken-2">
              Resumen por Programa
            </div>
            <v-text-field
              v-model="searchPrograma"
              dense
              outlined
              clearable
              hide-details
              placeholder="Buscar programa..."
              prepend-inner-icon="mdi-magnify"
              style="max-width: 300px;"
            />
          </div>
          
          <v-data-table
            :headers="headersResumen"
            :items="resumenPorPrograma"
            :loading="loading"
            :search="searchPrograma"
            dense
            disable-pagination
            hide-default-footer
            class="elevation-1 tabla-compacta"
            loading-text="Cargando resumen..."
            no-data-text="No hay datos para mostrar"
            @click:row="seleccionarProgramaRow"
          >
            <template v-slot:[`item.programa_nombre`]="{ item }">
              <span 
                class="font-weight-medium primary--text pointer-cursor"
                :class="{'font-weight-black text-decoration-underline': programaSeleccionado && programaSeleccionado.programa_nombre === item.programa_nombre}"
              >
                {{ item.programa_nombre }}
              </span>
            </template>
            <template v-slot:[`item.total`]="{ item }">
              <v-chip x-small color="blue-grey lighten-4" class="font-weight-bold">
                {{ item.total }}
              </v-chip>
            </template>
            <template v-slot:[`item.e0`]="{ item }"><span :class="{'grey--text text--lighten-1': !item.e0}">{{ item.e0 }}</span></template>
            <template v-slot:[`item.e1`]="{ item }"><span :class="{'grey--text text--lighten-1': !item.e1}">{{ item.e1 }}</span></template>
            <template v-slot:[`item.e2`]="{ item }"><span :class="{'grey--text text--lighten-1': !item.e2}">{{ item.e2 }}</span></template>
            <template v-slot:[`item.e3`]="{ item }"><span :class="{'grey--text text--lighten-1': !item.e3}">{{ item.e3 }}</span></template>
            <template v-slot:[`item.e4`]="{ item }"><span :class="{'grey--text text--lighten-1': !item.e4}">{{ item.e4 }}</span></template>
            <template v-slot:[`item.e5`]="{ item }"><span :class="{'grey--text text--lighten-1': !item.e5}">{{ item.e5 }}</span></template>
            <template v-slot:[`item.e6`]="{ item }"><span :class="{'grey--text text--lighten-1': !item.e6}">{{ item.e6 }}</span></template>
            <template v-slot:[`item.e7`]="{ item }"><span :class="{'grey--text text--lighten-1': !item.e7}">{{ item.e7 }}</span></template>
            <template v-slot:[`item.e8`]="{ item }"><span :class="{'grey--text text--lighten-1': !item.e8}">{{ item.e8 }}</span></template>
          </v-data-table>
        </div>

        <!-- Detalle de Inscritos del Programa Seleccionado -->
        <v-divider class="my-2"></v-divider>

        <div class="d-flex align-center justify-space-between mb-2">
          <div class="d-flex align-center" style="gap: 8px;">
            <v-btn
              v-if="is_descargar_inscritos"
              color="green"
              dark
              outlined
              x-small
              depressed
              :disabled="loading || !inscripcionesDelPrograma.length"
              @click="descargarCSV">
              <v-icon left small>mdi-download</v-icon>
              Descargar {{ programaSeleccionado ? 'Programa' : 'Todos' }}
            </v-btn>
            <span class="text-subtitle-2 font-weight-bold blue--text text--darken-3">
              {{ programaSeleccionado ? `Estudiantes de: ${programaSeleccionado.programa_nombre}` : 'Todos los estudiantes inscritos' }}
              ({{ inscripcionesDelPrograma.length }})
            </span>
            <v-btn v-if="programaSeleccionado" icon x-small @click="programaSeleccionado = null" title="Ver todos">
              <v-icon small color="red">mdi-close-circle</v-icon>
            </v-btn>
          </div>
          <v-text-field
            v-if="ver_tabla_inscritos"
            v-model="search"
            dense
            outlined
            clearable
            hide-details
            prepend-inner-icon="mdi-magnify"
            placeholder="Buscar estudiante..."
            style="max-width: 300px;"
          />
        </div>

        <v-data-table
          v-if="ver_tabla_inscritos"
          :headers="headers"
          :items="inscripcionesDelPrograma"
          :loading="loading"
          :items-per-page="20"
          :search="search"
          dense
          class="elevation-1 tabla-compacta"
          loading-text="Cargando inscripciones..."
          no-data-text="No hay inscripciones para mostrar"
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table" />
          </template>

          <template v-slot:[`item.estudiante_nombre`]="{ item }">
            {{ item.estudiante_nombre || '-' }}
          </template>

          <template v-slot:[`item.programa_nombre`]="{ item }">
            <span style="min-width: 250px; display: block;"> {{ item.programa_nombre || '-' }} </span>
          </template>

          <template v-slot:[`item.sede_nombre`]="{ item }">
            {{ item.sede_nombre || '-' }}
          </template>

          <template v-slot:[`item.fecha_inscripcion`]="{ item }">
            {{ parseFecha(item.fecha_inscripcion) }}
          </template>

          <template v-slot:[`item.asesor_nombre`]="{ item }">
            {{ item.asesor_nombre || '-' }}
          </template>

          <template v-slot:[`item.estado_administrativo_id`]="{ item }">
            <v-chip x-small class="font-weight-medium" :color="obtenerColorEstado(item.estado_administrativo_id)">
              {{ obtenerTextoEstado(item) }}
            </v-chip>
          </template>  

          <template v-slot:[`item.estado_programa`]="{ item }">
            <span> {{ item.estado_programa_padre }} ({{ item.estado_programa }}) </span>
          </template>  
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import gql from 'graphql-tag';
import { reporte_inscripciones_v2, estados_admins, getunidades, getInstituciones, ver_todos_asesores, ver_todas_sedes, ver_tabla_de_inscritos, descargar_inscritos, UNIDADES_CON_ESTADO_ADMINISTRATIVO } from './utils';

  export default {
    data() {
      return {
        loading: false,
        isLoadingAsesores: false,
        msg: '',
        search: '',
        searchPrograma: '',
        fechaInicio: '',
        fechaFin: '',
        gestion: 2026,
        estado_programa_padre_id: null,
        sedeSeleccionada: null,
        asesor: null,
        asesores: [],
        terminos: null,
        inscripciones: [],
        estado_administrativo: null,
        unidad_negocio: null,
        unidades: [
          {id:1, text:'esam'},
          {id:2, text:'cca'},
        ],
        convenio: null,
        convenios: [
          {id:9, text:'Siglo xx'},
          {id:301, text:'Upi'},
        ],
        programaSeleccionado: null,
        sel_todos_asesores: ver_todos_asesores(this),
        ver_todas_las_sedes: ver_todas_sedes(this),
        ver_tabla_inscritos: ver_tabla_de_inscritos(this),
        is_descargar_inscritos: descargar_inscritos(this),
        mapaEstados: {
          0: 'Sin estado',
          1: 'Prospecto',
          2: 'Preinscrito',
          3: 'Inscrito',
          4: 'Inscrito Transferido',
          5: 'Retirado',
          6: 'Retirado Cambiado',
          7: 'Observado',
          8: 'Reincorporado'
        },
        headersResumen: [
          { text: 'Programa', value: 'programa_nombre', align: 'start' },
          { text: 'Total', value: 'total', align: 'center', width: 65 },
          { text: 'Sin est (0)', value: 'e0', align: 'center', width: 65 },
          { text: 'Prospecto (1)', value: 'e1', align: 'center', width: 75 },
          { text: 'Preinscrito (2)', value: 'e2', align: 'center', width: 80 },
          { text: 'Inscrito (3)', value: 'e3', align: 'center', width: 75 },
          { text: 'Ins. Transf (4)', value: 'e4', align: 'center', width: 85 },
          { text: 'Retirado (5)', value: 'e5', align: 'center', width: 75 },
          { text: 'Ret. Camb (6)', value: 'e6', align: 'center', width: 80 },
          { text: 'Observado (7)', value: 'e7', align: 'center', width: 80 },
          { text: 'Reinc. (8)', value: 'e8', align: 'center', width: 70 },
        ],
        headers: [
          { text: 'Fecha inscripción', value: 'fecha_inscripcion', width: 130 },
          { text: 'Estudiante', value: 'estudiante_nombre' },
          { text: 'Programa', value: 'programa_nombre', width: 220 },
          { text: 'Sede', value: 'sede_nombre', width: 140 },
          { text: 'Asesor', value: 'asesor_nombre', width: 150 },
          { text: 'Estado Administrativo', value: 'estado_administrativo_id', width: 140 },
          { text: 'Plan de cobros', value: 'plan_cobro', width: 120 },
          { text: 'Estado del programa', value: 'estado_programa', width: 130 },
        ],
        estados_admins: estados_admins()
      };
    },
    computed: { 
      mostrarEstadoAdmin() {
        if (!this.unidad_negocio) return true;
        return UNIDADES_CON_ESTADO_ADMINISTRATIVO.includes(this.unidad_negocio.id);
      },
      resumenPorPrograma() {
        const grupos = {};
        this.inscripciones.forEach((item) => {
          const prog = item.programa_nombre || 'Sin Programa / No especificado';
          if (!grupos[prog]) {
            grupos[prog] = {
              programa_nombre: prog,
              total: 0,
              e0: 0,
              e1: 0,
              e2: 0,
              e3: 0,
              e4: 0,
              e5: 0,
              e6: 0,
              e7: 0,
              e8: 0,
            };
          }
          grupos[prog].total += 1;
          const est = item.estado_administrativo_id != null ? Number(item.estado_administrativo_id) : 0;
          if (est >= 0 && est <= 8) {
            grupos[prog][`e${est}`] += 1;
          } else {
            grupos[prog].e0 += 1;
          }
        });

        return Object.values(grupos).sort((a, b) => b.total - a.total);
      },
      inscripcionesDelPrograma() {
        if (!this.programaSeleccionado) {
          return this.inscripciones;
        }
        return this.inscripciones.filter(item => {
          const prog = item.programa_nombre || 'Sin Programa / No especificado';
          return prog === this.programaSeleccionado.programa_nombre;
        });
      }
    },
    watch: {
      '$store.state.CARGO': function() {
        this.listar();
      },
      sedeSeleccionada: function() {
        this.listar_asesores();
      },
      unidad_negocio: function(nuevaUnidad) {
        if (nuevaUnidad && !UNIDADES_CON_ESTADO_ADMINISTRATIVO.includes(nuevaUnidad.id)) {
          this.estado_administrativo = null;
        }
      },
    },
    methods: {
      seleccionarProgramaRow(item) {
        if (this.programaSeleccionado && this.programaSeleccionado.programa_nombre === item.programa_nombre) {
          this.programaSeleccionado = null;
        } else {
          this.programaSeleccionado = item;
        }
      },
      obtenerColorEstado(estId) {
        const colors = {
          0: 'grey lighten-3',
          1: 'blue lighten-4',
          2: 'amber lighten-4',
          3: 'green lighten-4',
          4: 'teal lighten-4',
          5: 'red lighten-4',
          6: 'orange lighten-4',
          7: 'purple lighten-4',
          8: 'indigo lighten-4',
        };
        return colors[estId] || 'grey lighten-3';
      },
      obtenerTextoEstado(item) {
        if (item.estado_administrativo_id != null && this.mapaEstados[item.estado_administrativo_id]) {
          return this.mapaEstados[item.estado_administrativo_id];
        }
        return this.estados_admins.find(x => x.id == item.estado_administrativo_id)?.text || 'Sin estado';
      },
      async listar() { 
        this.loading = true;
        this.msg = '';
        this.inscripciones = [];
        this.programaSeleccionado = null;

        try { 
          const qu = {
            gestion: this.gestion
          };
          
          if(this.asesor){
            qu.asesor_id = this.asesor.id;
          }
          if(this.estado_administrativo && this.mostrarEstadoAdmin){
            qu.estado_administrativo_id = this.estado_administrativo.id;
          }
          if(this.unidad_negocio){
            qu.unidad_negocio_id = this.unidad_negocio.id;
          }
          if(this.convenio){
            qu.convenio_id = this.convenio.id;
          }
          if(this.estado_programa_padre_id){
            qu.estado_programa_padre_id = this.estado_programa_padre_id;
          }
          if(this.sedeSeleccionada){
            qu.sede_id = [this.sedeSeleccionada.idsede];
          }
          if(!this.sedeSeleccionada && !this.ver_todas_las_sedes){
            const ids = this.$store.state.CARGOS.map(x => (x.idsede));
            qu.sede_id = ids;
          }

          const res = await reporte_inscripciones_v2(qu);

          this.inscripciones = Array.isArray(res) ? res : [];
        } catch (e) {
          window.console.error(e);
          this.msg = 'No se pudo cargar la lista de inscripciones y aceptaciones';
        } finally {
          this.loading = false;
        }
      },
      async listar_unidades(){
        const r = await getunidades();
        if(r){
          const units = r.map(x=>({ ...x, text: x.nombre }));
          this.unidades = units;
        } 
      },
      async listar_convenios(){
        const r = await getInstituciones(this);
        if(r){
          const conves = r.filter(x=>x.convenio);
          const cvs = conves.map(x=>({...x, text: `(${x.abreviatura}) ${x.nombre}`}));
          this.convenios = cvs;
        } 
      },
      setFechasDefault() {
        const fin = new Date();
        const inicio = new Date();
        inicio.setDate(1);
        this.fechaInicio = this.formatoFechaInput(inicio);
        this.fechaFin = this.formatoFechaInput(fin);
        this.estado_administrativo = this.estados_admins.find(x=>x.id == 3);
      },
      formatoFechaInput(date) {
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
      },
      descargarCSV() {
        const data = this.inscripcionesDelPrograma;
        if (!data.length) return;

        const allKeys = Array.from(
          new Set(data.flatMap(item => Object.keys(item)))
        );

        const isLowPriority = (key) => /_id$|_por$|_ins$/.test(key);
        const mainKeys = allKeys.filter(k => !isLowPriority(k));
        const lowPriorityKeys = allKeys.filter(k => isLowPriority(k));

        const orderedKeys = [...mainKeys, ...lowPriorityKeys];

        const rows = data.map((item) => {
          return orderedKeys.map((key) => {
            let val = item[key];
            if (key.startsWith('fecha_') && val) {
              val = this.parseFecha(val);
            }
            return val;
          });
        });

        const csv = [orderedKeys, ...rows].map((row) => row.map(this.valorCSV).join(',')).join('\n');
        const blob = new Blob([`\ufeff${csv}`], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        const nombreProg = this.programaSeleccionado ? this.programaSeleccionado.programa_nombre.substring(0, 20) : 'todos';
        link.download = `reporte-inscripciones-${nombreProg}-${this.gestion}.csv`;
        link.click();
        URL.revokeObjectURL(link.href);
      },
      valorCSV(value) {
        const text = String(value == null ? '' : value);
        return `"${text.replace(/"/g, '""')}"`;
      },
      parseFecha(f) {
        if (!f) return '';
        const fs = f.split(/[T ]/)[0].split('-');
        if (fs.length !== 3) return f;
        return `${fs[2]}/${fs[1]}/${fs[0]}`;
      },
      async listar_asesores(){
        this.asesores = [];
        this.asesor = null;
        if(!this.sedeSeleccionada) return;

        this.isLoadingAsesores = true;
        const sql = gql`query{ getSede(id:${this.sedeSeleccionada.idsede}){usuarios_activos{usuario{estado,datos_personales{id,nombres,pri_apellido,seg_apellido},cargos{cargo{id,nombre}},}}} }`;
        const data = await this.$apollo.query({ query: sql }).then((data) => data).catch((error) => error);
        this.isLoadingAsesores = false;
        const sed = data.data.getSede;
        const datas = [];
        if (sed.usuarios_activos == null) return;
        sed.usuarios_activos.forEach(function(e) {
          var dp = e.usuario.datos_personales;
          var seg = dp.seg_apellido == null ? '' : dp.seg_apellido;
          var no = dp.nombres + ' ' + dp.pri_apellido + ' ' + seg;
          let text = `${no} (${dp.id}) `;
          if (e.usuario.estado && e.usuario.datos_personales.id != 2)
            datas.push({ id: dp.id, nombres: no, text: text });
        });
        this.asesores = datas;

        if(!this.sel_todos_asesores) {
          const id = this.$store.state.DATA_USER.id;
          const ase = this.asesores.find(x=>x.id == id);
          this.asesor = ase;
          this.listar();
        }
      }
    },
    mounted() {
      this.setFechasDefault();
      this.listar_unidades();
      this.listar_convenios();
      if(this.sel_todos_asesores){
        this.listar();
      }
    },
  };
</script>

<style scoped>
.pointer-cursor {
  cursor: pointer;
}

/* Reducir padding vertical para máxima densidad/compactación */
.tabla-compacta >>> table tbody td,
.tabla-compacta >>> table thead th {
  padding-top: 2px !important;
  padding-bottom: 2px !important;
  padding-left: 6px !important;
  padding-right: 6px !important;
  height: 26px !important;
  font-size: 0.78rem !important;
}

.tabla-compacta >>> table tbody tr {
  cursor: pointer;
}

.tabla-compacta >>> table tbody tr:hover {
  background-color: #f0f4f8 !important;
}
</style>

